export default __webpack_public_path__ + "static/media/Gordon.d52e9633.png";